
// xType is a class (encoder/decoder) used to process the file
// we use decide the class by type
// i.e. to convert any image to jpg we use a unique method. which is same for jpeg
// so jpeg shouldnt be here, neither tif, mp4, webm.
export type FromType = 'powerpoint' |
    'excel' |
    'word' |
    'pdf' |
    'image' |
    'ps' |
    'video' |
    'audio' |
    'av' |
    'ebook' |
    'archive' |
    'files' |
    'text';

export class GenericMouseEvent {
    type: string;
    clientX: number;
    clientY: number;
    pageX: number;
    pageY: number;
    offsetX: number;
    target: any | null;
}

export class FromTypes {
    public static POWERPOINT: FromType = 'powerpoint';
    public static EXCEL: FromType = 'excel';
    public static WORD: FromType = 'word';
    public static PDF: FromType = 'pdf';
    public static IMAGE: FromType = 'image';
    public static PS: FromType = 'ps';
    public static VIDEO: FromType = 'video';
    public static AUDIO: FromType = 'audio';
    public static AV: FromType = 'av';
    public static EBOOK: FromType = 'ebook';
    public static ARCHIVE: FromType = 'archive';
    public static FILES: FromType = 'files';
    public static TEXT: FromType = 'text';
}

export enum ConvertType {
    Convert = 'convert',
    Compress = 'compress',
    Split = 'split',
    Merge = 'merge',
    All = 'all',
    Resize = 'resize',
    Meme = 'meme',
    Count = 'count',
    Encode = 'encode',
    Decode = 'decode',
    Crop = 'crop',
    Trim = 'trim',
    Cut = 'cut'
}

export type ToType = 'powerpoint' |
    'word' |
    'pdf' |
    'image' |
    'ps' |
    'png' |
    'jpg' |
    'tiff' |
    'webp' |
    'video' |
    'audio' |
    'ebook' |
    'jpeg' |
    'heic';
export class ToTypes {
    public static POWERPOINT: ToType = 'powerpoint';
    public static WORD: ToType = 'word';
    public static PDF: ToType = 'pdf';
    public static IMAGE: ToType = 'image';
    public static PS: ToType = 'ps';
    public static PNG: ToType = 'png';
    public static JPG: ToType = 'jpg';
    public static TIFF: ToType = 'tiff';
    public static WEBP: ToType = 'webp';
    public static VIDEO: ToType = 'video';
    public static AUDIO: ToType = 'audio';
    public static EBOOK: ToType = 'ebook';
    public static JPEG: ToType = 'jpeg';
    public static HEIC: ToType = 'heic';
}

export type ProcessType = 'convert' |
    'compress' |
    'split' |
    'merge' |
    'resize' |
    'extract' |
    'archive' |
    'encode' |
    'decode' |
    'count' |
    'url-encoder' |
    'url-decoder' |
    'base64-encode' |
    'base64-decode' |
    'word-count' |
    'meme' |
    'crop';
export class ProcessTypes {
    public static CONVERT: ProcessType = 'convert';
    public static COMPRESS: ProcessType = 'compress';
    public static EXTRACT: ProcessType = 'extract';
    public static ARCHIVE: ProcessType = 'archive';
    public static SPLIT: ProcessType = 'split';
    public static MERGE: ProcessType = 'merge';
    public static RESIZE: ProcessType = 'resize';
    public static CROP: ProcessType = 'crop';
    public static ENCODE: ProcessType = 'encode';
    public static DECODE: ProcessType = 'decode';
    public static COUNT: ProcessType = 'count';
    public static URL_ENCODER: ProcessType = 'url-encoder';
    public static URL_DECODER: ProcessType = 'url-decoder';
    public static BASE64_ENCODE: ProcessType = 'base64-encode';
    public static BASE64_DECODE: ProcessType = 'base64-decode';
    public static WORD_COUNT: ProcessType = 'word-count';
    public static MEME: ProcessType = 'meme';
}

export interface ServerReply {
    error: string;
    output: string | Array<string>;
    input: string | Array<string>;
}

export type StatusType = 'completed' |
    'started' |
    'failed' |
    'undefined';
export class StatusTypes {
    public static COMPLETED: StatusType = 'completed';
    public static STARTED: StatusType = 'started';
    public static FAILED: StatusType = 'failed';
    public static UNDEFINED: StatusType = 'undefined';
}

export type UniqueProcessType = string;

export interface INchanSubscriber {
    connected: true;
    desiredTransport: string[];
    lastMessageId: string;
    reconnect: 'persist';
    reconnectTimeout: number; // millies
    running: true;
    transport: {
        emit: any;
        name: 'websocket';
        opt: any;
        listener: WebSocket
    };
    url: string;
}

export type ProcessStageSubStateType = 'started' |
    'partial' |
    'failed' |
    'unknown' |
    'completed';
export class ProcessStageSubStateTypes {
    public static STARTED: ProcessStageSubStateType = 'started';
    public static PARTIAL: ProcessStageSubStateType = 'partial';
    public static FAILED: ProcessStageSubStateType = 'failed';
    public static UNKNOWN: ProcessStageSubStateType = 'unknown';
    public static COMPLETED: ProcessStageSubStateType = 'completed';
}

export type ProcessStageType = 'upload' |
    'queued' |
    'preprocess' |
    'processing' |
    'ready' |
    'zip' |
    'completed';
export class ProcessStageTypes {
    public static UPLOAD: ProcessStageType = 'upload';
    public static QUEUED: ProcessStageType = 'queued';
    public static PREPROCESS: ProcessStageType = 'preprocess';
    public static PROCESSING: ProcessStageType = 'processing';
    public static READY: ProcessStageType = 'ready';
    public static ZIP: ProcessStageType = 'zip';
    public static COMPLETED: ProcessStageType = 'completed';
}

export type DataType = 'percentage' |
    'ratio' |
    'notification' |
    'enforcement_error';
export class DataTypes {
    public static PERCENTAGE: DataType = 'percentage';
    public static RATIO: DataType = 'ratio';
    public static NOTIFICATION: DataType = 'notification';
}

export type WebsocketProcessType = 'convert-one-to-one' |
    'convert-one-to-many';
export class WebsocketProcessTypes {
    public static CONVERT_ONE_TO_ONE: WebsocketProcessType = 'convert-one-to-one';
    public static CONVERT_ONE_TO_MANY: WebsocketProcessType = 'convert-one-to-many';
}

export interface WebsocketResponse {
    uuid: string;
    processType: WebsocketProcessType;
    dataType: DataType;
    processStage: ProcessStageType;
    readableProcessStage: string;
    processStageSubState: ProcessStageSubStateType;
    data: string;
    result: string;
    priority: string;
    eventId: number;
}

/**
 * The edge's `ProcessResult` as the browser receives it — JSON-parsed out of
 * `WebsocketResponse.result` (websocket push) or the replay-history payload
 * (poll). Mirrors
 * `springboot-shared-library/.../workflows/ProcessResult.kt`; every field is
 * optional because the shape depends on which stage produced it and on which
 * jar version the serving edge is running.
 *
 * Written down (it was `any` everywhere) because CONVERT_ERROR now reports
 * `failureCode` and a metric attribute read off an untyped blob is a metric
 * that silently becomes UNKNOWN the day the field is renamed.
 */
export interface ProcessResult {
    id?: string;
    /** Mongo ObjectId of the workflow — the join key to `workflows` and Graylog. */
    workflowId?: string;
    type?: string;
    inputStorageType?: string;
    outputStorageType?: string;
    inputFiles?: string[];
    outputFiles?: string[];
    inputFilesWithSize?: any[];
    outputFilesWithSize?: any[];
    start?: any;
    end?: any;
    error?: boolean;
    ziped?: boolean;
    zip?: string;
    blobNames?: string[];
    originalOutputFiles?: string[];
    originalZip?: string;
    errorLogs?: string[];
    /** Edge domain that processed this workflow (patched onto endpointData). */
    processDomain?: string;
    downloadDomain?: string;
    processingNotes?: string[];
    /**
     * Structured failure taxonomy (METRICS.md §5: TOOL_NOT_FOUND,
     * ENCODER_REJECTED, OUTPUT_TOO_SMALL, ...). Additive and optional: an edge
     * running an older jar simply omits it, and CONVERT_ERROR then reports
     * `UNKNOWN` rather than dropping the event.
     */
    failureCode?: string;
    /**
     * Which part of a Studio render failed — STUDIO_DESIGN.md §3.5.
     *
     * Mirrors `springboot-shared-library/.../workflows/CompositionFailure.kt:22-33` field for
     * field. Separate from `failureCode`, which says what went wrong at the tool level: this says
     * WHICH clip and WHICH input, which is what the card needs to say "Clip 4 of 7
     * (beach-02.jpg) could not be rendered".
     *
     * Optional and additive: an edge on an older jar omits it and the render step falls back to
     * the generic copy, which is what §6.8's plain failure row says anyway.
     */
    compositionFailure?: {
        code?: string;
        /** 0-based index into the visual track, or absent when the failure is not clip-scoped. */
        clipIndex?: number;
        /** 0-based index into `originalInputFiles`, or absent. */
        input?: number;
        /** The user's own file name for `input` — never a path on disk. */
        safeName?: string;
    };
    /** Legacy download-link shape still read by FileUpload.getDownloadLinks(). */
    output?: string | string[];
    input?: string | string[];
    /** Pre-GCS-removal output paths, preferred by the single-file download name builder. */
    originalOutput?: string | string[];
    /** Per-file byte sizes keyed by path; drives the compression-ratio line. */
    sizes?: { outputs?: { [path: string]: any }, inputs?: { [path: string]: any } };
    /** Total output bytes; the chain-to-tool size guard reads it. */
    outputSize?: number;
    /**
     * Client-synthesised only: `file-process-editor` fabricates a result with
     * `dataType: 'enforcement_error'` so a 429 renders on the card like any
     * other failure. The edge never sends these two.
     */
    dataType?: string;
    data?: string;
}

export interface WebsocketDomainResponse {
    data: string;
    status: boolean;
}

export interface RowFileAndData {
    file: File;
    data?: any;
}

export type OriginalInputFileLocationType = 'local';
export class OriginalInputFileLocationTypes {
    public static LOCAL = 'local';
}

export interface OriginalInputFile {
    location: string;
    originalName: string;
    storageType: OriginalInputFileLocationType;
    metadata: any;
    gcName?: string;
    token?: string;
}

export type PSFileType = 'GOOGLE_DRIVE_FILE' |
    'DROPBOX_FILE' |
    'FILE';
export class PSFileTypes {
    public static GOOGLE_DRIVE_FILE = 'GOOGLE_DRIVE_FILE';
    public static DROPBOX_FILE = 'DROPBOX_FILE';
    public static FILE = 'FILE';
}

export type PSUploadType = 'server';
export class PSUploadTypes {
    public static SERVER = 'server';
}

export type OperationType = 'upload' |
    'process' |
    'generic';
export class OperationTypes {
    public static UPLOAD: OperationType = 'upload';
    public static PROCESS: OperationType = 'process';
    public static GENERIC: OperationType = 'generic';
}

export namespace FileMetadata {
    export function getFileIdFromSafeName(safeName: string) {
        const parts = safeName.split(/\-|\./);
        let tokenCount = parts.length - 1;
        while (tokenCount >= 0) {
            if (parts[tokenCount].length === 24) {
                return parts[tokenCount];
            }
            tokenCount--;
        }
        throw new Error('Failed to get uploaded file id from the given safe file name.');
    }
}

export interface FileMetadata {
    name: string;
    type: string;
    size: string;
    gcName: string;
    safeName: string;
}

export interface ProcessorMetadata {
    uploadDomain: string;
    processDomain: string;
    downloadDomain: string;
    thumbnailDomain: string;
    uploadType: PSUploadType;
    uploadEndpoint: string;
    processorEndpoint: string;
    uploadedFileDownloadEndpoint: string;
    downloadEndpoint: string;
    gcpTempDownloadEndpoint: string;
    emailDownloadEndpoint: string;
    imageShareEndpoint: string;
    thumbnailEndpoint: string;
    commEndpoint: string;
    zipEndpoint: string;
    fileMetadata: FileMetadata;
    postProcessMetadata: ProcessorMetadata;
}

export interface OrientationUpdateEvent {
    file: File;
    orientation: RotationAndFlip;
}

export type StringBoolean = 'true' | 'false';

export interface RotationAndFlip {
    angle: string;
    isFliped: StringBoolean; // true, false
    orientation?: string;
}